import { render, staticRenderFns } from "./Matrix2View.vue?vue&type=template&id=77a785e6"
import script from "./Matrix2View.vue?vue&type=script&lang=js"
export * from "./Matrix2View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports